export default __webpack_public_path__ + "static/media/TereeTransparent.f95a539d.png";